export default __webpack_public_path__ + "static/media/collection_icon.7118405f.svg";